// @flow

import { jitsiLocalStorage } from '@jitsi/js-utils';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';

import { SET_CONFIG, overwriteConfig, overwriteInterfaceConfig } from '../config';
import getRoomName from '../config/getRoomName';
import { SET_LOCATION_URL } from '../connection';
import { setAutoPassword, setDesktopApp } from '../mtApi';
import { SET_OCCURANCE_ID } from '../mtApi/actionTypes';
import {
    getLocalParticipant,
    participantUpdated
} from '../participants';
import { MiddlewareRegistry } from '../redux';
import { updateSettings } from '../settings';
import { isJsonString, parseURLParams } from '../util';

import { JWT_STORAGE, MEETING_TIMING, SET_ACCESS_TOKEN,
    SET_JWT, SET_MEETING_INFO, SET_USER_ROLE, SET_USER_SETTING } from './actionTypes';
import { setJWT } from './actions';
import { GUEST_USER, MEETHOUR_USER, REGISTERED_USER, userType, usertypeList } from './constants';
import { parseJWTFromURLParams } from './functions';
import logger from './logger';

// import { overrideConfigJSON } from '../config/functions.any';

declare var APP: Object;
declare var config: Object;
declare var interfaceConfig: Object;

// declare var loggingConfig: Object;

/**
 * Middleware to parse token data upon setting a new room URL.
 *
 * @param {Store} store - The redux store.
 * @private
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
    case SET_CONFIG:
    case SET_LOCATION_URL:
        // XXX The JSON Web Token (JWT) is not the only piece of state that we
        // have decided to store in the feature jwt
        return _setConfigOrLocationURL(store, next, action);

    case SET_JWT:
        return _setJWT(store, next, action);

    case JWT_STORAGE:
        return _setJWTStorage(store, next, action);
    }

    return next(action);
});

/**
 * Overwrites the properties {@code avatarURL}, {@code email}, and {@code name}
 * of the local participant stored in the redux state base/participants.
 *
 * @param {Store} store - The redux store.
 * @param {Object} localParticipant - The {@code Participant} structure to
 * overwrite the local participant stored in the redux store base/participants
 * with.
 * @private
 * @returns {void}
 */
function _overwriteLocalParticipant(
        { dispatch, getState },
        { avatarURL, email, name, features }) {
    let localParticipant;

    if ((avatarURL || email || name)
            && (localParticipant = getLocalParticipant(getState))) {
        const newProperties: Object = {
            id: localParticipant.id,
            local: true
        };

        if (avatarURL) {
            newProperties.avatarURL = avatarURL;
        }
        if (email) {
            newProperties.email = email;
        }
        if (name) {
            newProperties.name = name;
        }
        if (features) {
            newProperties.features = features;
        }

        dispatch(updateSettings({
            avatarURL: avatarURL ? avatarURL : undefined,
            displayName: name ? name : undefined,
            email: email ? email : undefined

        }));
        dispatch(participantUpdated(newProperties));
    }
}

/**
 * Notifies the feature jwt that the action {@link SET_CONFIG} or
 * {@link SET_LOCATION_URL} is being dispatched within a specific redux
 * {@code store}.
 *
 * @param {Store} store - The redux store in which the specified {@code action}
 * is being dispatched.
 * @param {Dispatch} next - The redux dispatch function to dispatch the
 * specified {@code action} to the specified {@code store}.
 * @param {Action} action - The redux action {@code SET_CONFIG} or
 * {@code SET_LOCATION_URL} which is being dispatched in the specified
 * {@code store}.
 * @private
 * @returns {Object} The new state that is the result of the reduction of the
 * specified {@code action}.
 */
function _setConfigOrLocationURL({ dispatch, getState }, next, action) {
    const result = next(action);

    const { locationURL } = getState()['features/base/connection'];

    if (locationURL) {
        // document.title = interfaceConfig.APP_NAME;;//?
        // eslint-disable-next-line camelcase

        const urrr = parseURLParams(locationURL, true, 'search')?.access_token;
        const urrrw = new URL(locationURL);

        // const { URL_PREFIX } = getState()['features/base/config'];

        // console.log('locationUrll', window.document.referrer !== URL_PREFIX, urrrw.pathname === '/', urrrw, parseURLParams(locationURL, true, 'search'));
        // const urlReferrer = [
        //     URL_PREFIX,
        //     'https://www.linkedin.com/',
        //     'https://www.facebook.com/',
        //     'https://api.twitter.com/'
        // eslint-disable-next-line max-len
        // ];        if (urrr && !parseURLParams(locationURL, true, 'search').mt && urrrw.pathname === '/' && (urlReferrer.includes(window.document.referrer) || window.document.referrer.includes('.google.'))) {


        if (urrr && !parseURLParams(locationURL, true, 'search').mt && urrrw.pathname === '/') {
            dispatch({ type: SET_ACCESS_TOKEN,
                accessToken: urrr });
            jitsiLocalStorage.setItem('accessToken', urrr);
            dispatch(updateSettings({
                accessToken: urrr
            }));


            // window.history.replaceState(
            //     history.state,
            //     (document && document.title) || '',
            //     urlwithout);
        }

        // sets password through url or from local storage if exists
        if (urrrw.pathname !== '/') {

            // Checking if we already have pcode in localstorage for this meeting
            const pcode = jitsiLocalStorage.getItem('autopcode');
            const roomName12 = getRoomName(locationURL);
            let pass;

            if (pcode === null) {
                pass = parseURLParams(locationURL, true, 'search')?.pcode;
            } else {

                const jsonString = isJsonString(pcode) ? JSON.parse(pcode) : null;

                const localSessionPcode = jsonString[`${roomName12?.toLocaleLowerCase()}`] ? jsonString[`${roomName12?.toLocaleLowerCase()}`] : undefined;

                // Taking the pcode from URL or from Local Storage. But the preference is from Pcode coming from URL.
                pass = parseURLParams(locationURL, true, 'search')?.pcode ?? localSessionPcode;
            }

            const stringRoom = isJsonString(pcode) ? JSON.parse(pcode) : {};
            const roomNames = {
                ...stringRoom,
                [`${roomName12}`]: pass
            };


            jitsiLocalStorage.setItem('autopcode', JSON.stringify(roomNames));
            dispatch(setAutoPassword(pass));
        }
        if (urrrw.pathname !== '/' && parseURLParams(locationURL, true, 'search').desktopapp) {
            const pass = parseURLParams(locationURL, true, 'search')?.desktopapp;

            // eslint-disable-next-line radix
            dispatch(setDesktopApp(parseInt(pass)));
        }
        const jwt = parseJWTFromURLParams(locationURL);

        const jwtPayload = jwt ? jwtDecode(jwt) : null;

        if (jwtPayload && jwtPayload.moderator === true) {

            dispatch(
                setJWT(jwt));

            return result;
        }

        if (jwtPayload && !jwtPayload?.moderator) {
            dispatch(
                { type: JWT_STORAGE,
                    jwtData: jwt });
        }

    }


    return result;
}

/**
 * Notifies the feature jwt that the action {@link SET_JWT} is being dispatched
 * within a specific redux {@code store}.
 *
 * @param {Store} store - The redux store in which the specified {@code action}
 * is being dispatched.
 * @param {Dispatch} next - The redux dispatch function to dispatch the
 * specified {@code action} to the specified {@code store}.
 * @param {Action} action - The redux action {@code SET_JWT} which is being
 * dispatched in the specified {@code store}.
 * @private
 * @returns {Object} The new state that is the result of the reduction of the
 * specified {@code action}.
 */
function _setJWT(store, next, action) {
    // eslint-disable-next-line no-unused-vars
    const { jwt, type, ...actionPayload } = action;

    if (!Object.keys(actionPayload).length) {
        if (jwt) {
            let jwtPayload;
            let jwtPayload1;

            try {
                jwtPayload = jwtDecode(jwt);
                jwtPayload1 = jwtDecode(jwt, { header: true });
            } catch (e) {
                logger.error(e);
            }
            // eslint-disable-next-line camelcase
            const accessToken = jwtPayload1?.access_token;


            if (accessToken) {
                // console.log('setAccessToken', accessToken);
                store.dispatch({ type: SET_ACCESS_TOKEN,
                    accessToken });
                jitsiLocalStorage.setItem('accessToken', accessToken);
                store.dispatch(updateSettings({
                    accessToken
                }));
            }
            if (jwtPayload) {

                const { context, iss, options, user_type, meeting } = jwtPayload;
                const { dispatch } = store;

                action.jwt = jwt;
                action.issuer = iss;

                if (!_.isEmpty(meeting?.start_time) && !_.isEmpty(meeting?.end_time)) {

                    dispatch({ type: MEETING_TIMING,
                        mtTime: { startTime: meeting.start_time,
                            endTime: meeting.end_time } });
                }
                if (meeting?.settings) {
                    const { settings } = meeting;

                    dispatch({ type: SET_USER_SETTING,
                        confSetting: settings });
                }
                if (meeting?.occurrence_id) {
                    const { occurrence_id } = meeting;

                    dispatch({
                        type: SET_OCCURANCE_ID,
                        occurrenceId: occurrence_id
                    });
                }
                const user1 = _user2participant(context.user || {});

                if (user1?.moderator) {
                    dispatch({ type: SET_USER_ROLE,
                        localUserRole: user1?.moderator });
                } else {
                    dispatch({ type: SET_USER_ROLE,
                        localUserRole: 'none' });
                }

                if (context || user_type) {
                    const user = _user2participant(context.user || {});

                    jitsiLocalStorage.setItem('userLocal', JSON.stringify(user));
                    action.callee = context.callee;
                    action.group = context.group;
                    action.server = context.server;
                    action.tenant = context.tenant;
                    action.user = user;

                    user && _overwriteLocalParticipant(
                        store, { ...user,
                            features: context.features });
                }

                const usertype = usertypeList.indexOf(user_type);

                if (meeting) {
                    dispatch({
                        type: SET_MEETING_INFO,
                        meeting
                    });
                }

                const confgNative = store.getState()['features/base/config'];


                let IsMeetHourInFrame = false;

                // Checking If Meet Hour is running in an Iframe or not. By default value is false
                if (window.self !== window.top) {
                    // The code is running inside an iframe
                    IsMeetHourInFrame = true;
                }

                // Web App Case - Apply JWT Overwrite settings coming from External JWT
                if (!_.isEmpty(options?.configoverwrite)
                && (userType[`${usertypeList[usertype]}`] === MEETHOUR_USER
                || userType[`${usertypeList[usertype]}`] === REGISTERED_USER || userType[`${usertypeList[usertype]}`] === GUEST_USER)
                && IsMeetHourInFrame === true && config?.iAmRecorder !== true
                ) {

                    const configOverwrite = options?.configoverwrite;

                    const dev = _.pick(configOverwrite, typeof config === 'undefined' ? Object.keys(confgNative) : Object.keys(config));
                    // eslint-disable-next-line no-confusing-arrow
                    const dev1 = _.mergeWith(configOverwrite, dev, (oldValue, newValue) =>

                    // XXX We don't want to merge the arrays, we want to
                    // overwrite them.
                        Array.isArray(oldValue) ? newValue : undefined
                    );

                    // eslint-disable-next-line max-depth, no-negated-condition
                    if (typeof APP !== 'undefined') {
                        config = Object.assign(config, dev1);
                        dispatch(overwriteConfig(config));

                    }

                }


                // Web App Case - Apply JWT Overwrite settings coming from External JWT
                if (!_.isEmpty(options?.interfaceconfigoverwrite) && typeof APP !== 'undefined' && interfaceConfig?.applyMeetingSettings === true) {
                    const dev = _.pick(options?.interfaceconfigoverwrite, Object.keys(interfaceConfig));

                    // eslint-disable-next-line no-confusing-arrow
                    const dev1 = _.mergeWith(options?.interfaceconfigoverwrite, dev, (oldValue, newValue) =>

                        // XXX We don't want to merge the arrays, we want to
                        // overwrite them.
                        Array.isArray(oldValue) ? newValue : undefined
                    );

                    interfaceConfig = Object.assign(interfaceConfig, dev1);


                    // console.log('interfaceconfigoverwrite', options?.interfaceconfigoverwrite);
                    // overrideConfigJSON(config, interfaceConfig, loggingConfig, options);
                }
            }
        } else if (typeof APP === 'undefined') {
            // The logic of restoring JWT overrides make sense only on mobile.
            // On Web it should eventually be restored from storage, but there's
            // no such use case yet.

            const { user } = store.getState()['features/base/jwt'];

            user && _undoOverwriteLocalParticipant(store, user);
        }
    }

    return next(action);
}

/**
 * Notifies the feature jwt that the action {@link JWT_STORAGE} is being dispatched
 * within a specific redux {@code store}.
 *
 * @param {Store} store - The redux store in which the specified {@code action}
 * is being dispatched.
 * @param {Dispatch} next - The redux dispatch function to dispatch the
 * specified {@code action} to the specified {@code store}.
 * @param {Action} action - The redux action {@code JWT_STORAGE} which is being
 * dispatched in the specified {@code store}.
 * @private
 * @returns {Object} The new state that is the result of the reduction of the
 * specified {@code action}.
 */
function _setJWTStorage(store, next, action) {
    // eslint-disable-next-line no-unused-vars
    const { jwtData, type, ...actionPayload } = action;

    if (!Object.keys(actionPayload).length) {
        if (jwtData) {
            let jwtPayload;
            let jwtPayload1;

            try {
                jwtPayload = jwtDecode(jwtData);

                jwtPayload1 = jwtDecode(jwtData, { header: true });
            } catch (e) {
                logger.error(e);
            }
            // eslint-disable-next-line camelcase
            const accessToken = jwtPayload1?.access_token;


            if (accessToken) {
                store.dispatch({ type: SET_ACCESS_TOKEN,
                    accessToken });
                jitsiLocalStorage.setItem('accessToken', accessToken);
                store.dispatch(updateSettings({
                    accessToken
                }));
            }
            if (jwtPayload) {

                const { context, iss, options, user_type, meeting } = jwtPayload;
                const { dispatch, getState } = store;
                const state = getState();

                action.jwt = jwtData;
                action.issuer = iss;
                if (Boolean(jwtPayload.moderator === true) && !state['features/base/jwt']?.jwt) {

                    dispatch(
                        setJWT(jwtData));
                }

                // if (lobby) {

                //     dispatch(enableLobby(lobby));
                //     setTimeout(() => {
                //         console.log('lobbyModde', getState()['features/lobby'].enableLobby);
                //     }, 2000);
                // }

                if (meeting?.settings) {
                    const { settings } = meeting;


                    dispatch({ type: SET_USER_SETTING,
                        confSetting: settings });
                }

                if (meeting?.occurrence_id) {
                    const { occurrence_id } = meeting;

                    dispatch({
                        type: SET_OCCURANCE_ID,
                        occurrenceId: occurrence_id
                    });
                }
                if (!_.isEmpty(meeting?.start_time) && !_.isEmpty(meeting?.end_time)) {

                    dispatch({ type: MEETING_TIMING,
                        mtTime: { startTime: meeting.start_time,
                            endTime: meeting.end_time } });
                }
                const user1 = _user2participant(context.user || {});

                if (user1?.moderator) {
                    dispatch({ type: SET_USER_ROLE,
                        localUserRole: user1?.moderator });
                } else {
                    dispatch({ type: SET_USER_ROLE,
                        localUserRole: 'none' });
                }

                if (context || user_type) {
                    const user = _user2participant(context.user || {});

                    jitsiLocalStorage.setItem('userLocal', JSON.stringify(user));
                    action.callee = context.callee;
                    action.group = context.group;
                    action.server = context.server;
                    action.tenant = context.tenant;
                    action.user = user;

                    user && _overwriteLocalParticipant(
                            store, { ...user,
                                features: context.features });
                }

                const usertype = usertypeList.indexOf(user_type);

                if (meeting) {
                    dispatch({
                        type: SET_MEETING_INFO,
                        meeting
                    });
                }
                const confgNative = store.getState()['features/base/config'];
                const intConfig = confgNative.interfaceConfig;


                let IsMeetHourInFrame = false;

                // Checking If Meet Hour is running in an Iframe or not. By default value is false
                if (window.self !== window.top) {
                    // The code is running inside an iframe
                    IsMeetHourInFrame = true;
                }

                // Web App Case - Apply JWT Overwrite settings coming from External JWT
                if (!_.isEmpty(options?.configoverwrite)
                && (userType[`${usertypeList[usertype]}`] === MEETHOUR_USER
                || userType[`${usertypeList[usertype]}`] === REGISTERED_USER || userType[`${usertypeList[usertype]}`] === GUEST_USER)
                && IsMeetHourInFrame === true && config?.iAmRecorder !== true
                ) {
                    const configOverwrite = options?.configoverwrite;

                    const dev = _.pick(configOverwrite, typeof config === 'undefined' ? Object.keys(confgNative) : Object.keys(config));

                    // eslint-disable-next-line no-confusing-arrow
                    const dev1 = _.mergeWith(configOverwrite, dev, (oldValue, newValue) =>

                    // XXX We don't want to merge the arrays, we want to
                    // overwrite them.
                        Array.isArray(oldValue) ? newValue : undefined
                    );


                    // eslint-disable-next-line max-depth, no-negated-condition
                    if (typeof APP !== 'undefined') {
                        config = Object.assign(config, dev1);

                        dispatch(overwriteConfig(config));

                    }

                }


                // Web App Case - Apply JWT Overwrite settings coming from External JWT
                if (!_.isEmpty(options?.interfaceconfigoverwrite) && typeof APP !== 'undefined') {
                    const dev = _.pick(options?.interfaceconfigoverwrite, Object.keys(interfaceConfig));
                    // eslint-disable-next-line no-confusing-arrow
                    const dev1 = _.mergeWith(options?.interfaceconfigoverwrite, dev, (oldValue, newValue) =>

                    // XXX We don't want to merge the arrays, we want to
                    // overwrite them.

                        Array.isArray(oldValue) ? newValue : undefined
                    );

                    // eslint-disable-next-line max-depth
                    if (typeof APP !== 'undefined' && (interfaceConfig?.applyMeetingSettings === true || config.iAmRecorder === true)) {

                        // This will execute in the case of Recorder
                        interfaceConfig = Object.assign(interfaceConfig, dev1);

                    }

                    // eslint-disable-next-line max-depth
                    if (intConfig?.applyMeetingSettings === true) {
                        const interfaceConfigs = Object.assign(intConfig, dev1);

                        dispatch(overwriteInterfaceConfig(interfaceConfigs));
                    }

                    // console.log('interfaceconfigoverwrite', options?.interfaceconfigoverwrite);
                    // overrideConfigJSON(config, interfaceConfig, loggingConfig, options);

                }

            }
        } else if (typeof APP === 'undefined') {
            // The logic of restoring JWT overrides make sense only on mobile.
            // On Web it should eventually be restored from storage, but there's
            // no such use case yet.

            const { user } = store.getState()['features/base/jwt'];

            user && _undoOverwriteLocalParticipant(store, user);
        }
    }

    return next(action);
}


/**
 * Undoes/resets the values overwritten by {@link _overwriteLocalParticipant}
 * by either clearing them or setting to default values. Only the values that
 * have not changed since the overwrite happened will be restored.
 *
 * NOTE Once it is possible to edit and save participant properties, this
 * function should restore values from the storage instead.
 *
 * @param {Store} store - The redux store.
 * @param {Object} localParticipant - The {@code Participant} structure used
 * previously to {@link _overwriteLocalParticipant}.
 * @private
 * @returns {void}
 */
function _undoOverwriteLocalParticipant(
        { dispatch, getState },
        { avatarURL, name, email }) {
    let localParticipant;

    if ((avatarURL || name || email)
            && (localParticipant = getLocalParticipant(getState))) {
        const newProperties: Object = {
            id: localParticipant.id,
            local: true
        };

        if (avatarURL === localParticipant.avatarURL) {
            newProperties.avatarURL = undefined;
        }
        if (email === localParticipant.email) {
            newProperties.email = undefined;
        }
        if (name === localParticipant.name) {
            newProperties.name = undefined;
        }
        newProperties.features = undefined;

        dispatch(participantUpdated(newProperties));
    }
}

/**
 * Converts the JWT {@code context.user} structure to the {@code Participant}
 * structure stored in the redux state base/participants.
 *
 * @param {Object} user - The JWT {@code context.user} structure to convert.
 * @private
 * @returns {{
 *     avatarURL: ?string,
 *     email: ?string,
 *     id: ?string,
 *     name: ?string,
 *     moderator: ?boolean,
 * }}
 */
function _user2participant({ avatar, avatarUrl, email, id, name, moderator }) {
    const participant = {};

    if (typeof avatarUrl === 'string') {
        participant.avatarURL = avatarUrl.trim();
    } else if (typeof avatar === 'string') {
        participant.avatarURL = avatar.trim();
    }
    if (typeof email === 'string') {
        participant.email = email.trim();
    }
    if (typeof id === 'string') {
        participant.id = id.trim();
    }
    if (typeof name === 'string') {
        participant.name = name.trim();
    }
    if (typeof moderator === 'boolean') {
        participant.moderator = moderator;
    }

    return Object.keys(participant).length ? participant : undefined;
}
